import type { Workflow, Task, WorkflowVariable } from './types'

function uid(prefix: string) {
  return `${prefix}_${Math.random().toString(36).slice(2, 9)}`
}

export function importWorkflowJson(raw: unknown, accountId: string): Workflow {
  const o = raw as Record<string, any>
  const now = new Date().toISOString()
  return {
    id: uid('wf'),
    accountId,
    name: String(o.name ?? 'Untitled Workflow'),
    description: o.description ?? '',
    version: Number(o.version ?? 1),
    tags: Array.isArray(o.tags) ? o.tags.map(String) : [],
    variables: (o.variables ?? []) as WorkflowVariable[],
    tasks: (o.tasks ?? []) as Task[],
    webhook: { url: '', headers: {}, events: ['workflow.completed'], retryCount: 3 },
    defaultErrorHandling: o.defaultErrorHandling ?? { ignoreErrors: false },
    configFiles: {},
    createdAt: now,
    updatedAt: now,
  }
}

// Export back to the Ops Center JSON shape (drops mockup-only fields).
export function exportWorkflowJson(wf: Workflow): Record<string, unknown> {
  return {
    name: wf.name,
    description: wf.description ?? '',
    version: wf.version,
    tags: wf.tags,
    variables: wf.variables,
    tasks: wf.tasks,
    defaultErrorHandling: wf.defaultErrorHandling ?? { ignoreErrors: false },
    isTemplate: false,
  }
}
